import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 48px;

  @media ${({ theme }) => theme.media.desktop} {
    grid-template-columns: 1fr 1fr;
    gap: 64px;
    margin-block: 42px;
  }
`;
